import {
  BarcodeLocation,
  DocumentFormat,
  EntryMode,
  entryModes,
  ExitMode,
  exitModes,
  FieldsSection,
  FolderItem,
  Hospitalisation,
  Patient,
  PatientDocument,
} from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import React, { useRef, useState } from "react";

import { getImgUrl, getItemId, getUserShortName, uid } from "@/src/utils/utils";
import {
  DocumentEditorToolbar,
  DocumentToolbarButtonType,
} from "./documentEditorToolbar";

import { cleanHtmlEscaping, getAge, isCabinet } from "@/src/utils/utils";
import moment from "moment";
import Barcode from "react-barcode";
import { EditServiceDocumentButton } from "../admin/structures/documentServiceInfoDrawer";
import { AutopsyAttachments } from "../patients/patientMedecineLegale";
import { AiAudioDocumentEditorButton } from "./aiAudioDocumentEditorButton";
import { DocumentFooter } from "./documentFooter";
import { DocumentHeader } from "./documentHeader";
import { replaceVariablesWithValues } from "./variablesHook";

function DocumentEditor({
  isTemplate,
  patientDocument,
  currentTitle,
  currentContent,
  allowedButtons,
  onSave,
  onPrint,
  onClose,
  onValidate,
  onChange,
  onTitleChange,
  getSubHeader,
  sections,
  showHeader,
  showLeftBar,
  barcodeLocation,
  showTitle,
  showHorizontalScroll,
}: {
  isTemplate: boolean;
  patientDocument: PatientDocument | null | undefined;
  currentTitle: any;
  currentContent: any;
  allowedButtons: DocumentToolbarButtonType[];
  onSave?: () => void;
  onPrint?: () => void;
  onClose?: () => void;
  onValidate?: () => void;
  onChange?: (newContent: any) => void;
  onTitleChange?: (newContent: any) => void;
  getSubHeader?: (
    patientDocument: PatientDocument | null | undefined
  ) => JSX.Element | null | undefined;

  sections: (FieldsSection | null | undefined)[] | null | undefined;
  showHeader?: boolean;
  showLeftBar?: boolean;
  barcodeLocation?: BarcodeLocation | null;
  showTitle?: boolean;
  showHorizontalScroll?: boolean;
}) {
  const titleRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  const [format, setFormat] = React.useState<DocumentFormat>("a4");
  const [isHtmlMode, setIsHtmlMode] = React.useState(false);
  let [title, setTitle] = useState(currentTitle || "Nouveau document");
  let [content, setContent] = useState(currentContent || "");

  return (
    <div
      id="documentEditorContainer"
      style={{
        width: format == "a4" ? 810 : 420,
      }}
    >
      <DocumentEditorContent
        key={uid()}
        titleRef={titleRef}
        contentRef={contentRef}
        format={format}
        isHtmlMode={isHtmlMode}
        currentContent={content}
        currentTitle={title}
        patientDocument={patientDocument}
        getSubHeader={getSubHeader}
        onTitleChange={onTitleChange}
        isTemplate={isTemplate}
        onChange={(newValue) => {
          content = newValue;
          onChange?.(newValue);
        }}
        showHeader={showHeader}
        showLeftBar={showLeftBar}
        barcodeLocation={barcodeLocation}
        showTitle={showTitle}
        showHorizontalScroll={showHorizontalScroll}
      ></DocumentEditorContent>

      <DocumentEditorToolbar
        contentRef={contentRef}
        patientDocument={patientDocument}
        allowedButtons={allowedButtons}
        isHtmlMode={isHtmlMode}
        sections={sections}
        onChange={(newValue) => {
          content = newValue;
          onChange?.(newValue);
        }}
        onSave={async () => {
          // contentRef.current!.innerHTML = content;
          onChange?.(content);
          await onSave?.();
        }}
        onPrint={onPrint}
        onValidate={onValidate}
        onHtmlModeChange={() => {
          setContent(content);
          setIsHtmlMode(!isHtmlMode);
        }}
        onFormatChange={(newFormat) => {
          setFormat(newFormat);
        }}
      ></DocumentEditorToolbar>
    </div>
  );
}
function DocumentEditorContent({
  isTemplate,
  isMini,
  titleRef,
  contentRef,
  format,
  patientDocument,
  currentTitle,
  currentContent,
  isHtmlMode,
  onChange,
  onKeyUp,
  onTitleChange,
  getSubHeader,
  showHeader,
  showLeftBar,
  barcodeLocation,
  showTitle,
  showHorizontalScroll,
}: {
  isTemplate: boolean;
  isMini?: boolean;
  titleRef: React.RefObject<HTMLDivElement>;
  contentRef: React.RefObject<HTMLDivElement>;
  format: DocumentFormat;
  patientDocument: PatientDocument | null | undefined;
  getSubHeader?: (
    patientDocument: PatientDocument | null | undefined
  ) => JSX.Element | null | undefined;
  currentTitle: any;
  currentContent: any;
  isHtmlMode: boolean;
  onChange?: (newContent: any) => void;
  onKeyUp?: (newContent: any) => void;
  onTitleChange?: (newContent: any) => void;
  showHeader?: boolean;
  showLeftBar?: boolean;
  barcodeLocation?: BarcodeLocation | null;
  showTitle?: boolean;
  showHorizontalScroll?: boolean;
}) {
  const [reload, setReload] = useState(0);
  const audioEditorRef = useRef<HTMLDivElement>(null);

  const service = USER.get()?.service;
  async function onContentInput() {
    let newContent = contentRef.current?.innerHTML;
    if (isHtmlMode && newContent) newContent = cleanHtmlEscaping(newContent);

    if (newContent == currentContent) return newContent;
    onChange?.(newContent);
    console.log("the current ref", window.getSelection());
    contentRef.current?.focus?.();
    audioEditorRef.current?.click?.();
    return newContent;
  }

  function onTitleInput() {
    const newTitle = titleRef.current?.innerHTML;
    if (newTitle == currentTitle) return;
    onTitleChange?.(newTitle);
  }

  if (
    (patientDocument?.template?.name?.toLowerCase() ==
      "pièces jointes autopsie" ||
      patientDocument?.title?.toLowerCase() == "pièces jointes autopsie") &&
    patientDocument?.patient
  )
    return (
      <div id="documentEditor">
        <div
          id="documentEditorPrintable"
          className="documentEditorPage"
          style={{
            width: format == "a4" ? 794 : 420,
            height: format == "a4" ? 1123 : 595,
          }}
        >
          <AutopsyAttachments
            patient={patientDocument?.patient}
            current={[]}
            onChange={() => {}}
          ></AutopsyAttachments>
        </div>
      </div>
    );

  if (isMini == true) {
    console.log("inside is mini " + currentContent);
    return (
      <div
        id="documentEditorPrintable"
        key={`documentContent ${patientDocument?.id}`}
        className="documentContent"
        ref={contentRef}
        contentEditable
        onInput={() => {
          onContentInput();
        }}
        onKeyUp={
          onKeyUp
            ? async () => {
                onKeyUp(await onContentInput());
              }
            : undefined
        }
        onChange={() => {
          onContentInput();
        }}
        dangerouslySetInnerHTML={{
          __html: isHtmlMode
            ? currentContent
            : `${
                isTemplate
                  ? currentContent
                  : replaceVariablesWithValues({
                      content: currentContent,
                      patientDocument,
                    })
              }`,
        }}
      ></div>
    );
  }

  return (
    <div
      id="documentEditor"
      style={{ overflowX: showHorizontalScroll ? "auto" : "hidden" }}
    >
      <div
        id="documentEditorPrintable"
        className={`documentEditorPage format-${format} theme-${service?.theme} themeColor-${service?.color}`}
        style={{
          width: format == "a4" ? 794 : 420,
          height: format == "a4" ? 1123 : 595,
        }}
      >
        <EditServiceDocumentButton
          onOpen={() => {
            setReload(reload + 1);
          }}
          onClose={() => {
            setReload(reload + 1);
          }}
          onChange={() => {
            setReload(reload + 1);
          }}
        />

        {showHeader ? <DocumentHeader format={format} /> : <></>}

        <div className="documentBody">
          {showLeftBar ? (
            <DocumentLeftBar
              barcodeLocation={barcodeLocation}
              patientDocument={patientDocument}
            ></DocumentLeftBar>
          ) : (
            <div></div>
          )}

          <div className="relative" style={{ zIndex: 10 }}>
            {getSubHeader ? getSubHeader(patientDocument) : <></>}

            {barcodeLocation == "title" && (
              <div className="mtop10">
                <DocumentBarcode
                  patientDocument={patientDocument}
                ></DocumentBarcode>
              </div>
            )}

            {showTitle ? (
              <div
                key={`documentTitle ${patientDocument?.id}`}
                className="documentTitle"
                ref={titleRef}
                contentEditable={true}
                dangerouslySetInnerHTML={{
                  __html: isHtmlMode
                    ? null
                    : currentTitle || "Nouveau dooooocument",
                }}
                onInput={() => {
                  onTitleInput();
                }}
                onChange={() => {
                  onTitleInput();
                }}
              >
                {isHtmlMode ? currentTitle : null}
              </div>
            ) : (
              <></>
            )}

            <div className="relative" style={{ zIndex: 10 }}>
              <AiAudioDocumentEditorButton
                ref={audioEditorRef}
                editorRef={contentRef}
                patient={patientDocument?.patient}
                currentPatientDocument={patientDocument}
                onChange={(newPatientDocument, newAiEdits) => {
                  patientDocument = newPatientDocument;
                  const el = contentRef.current;
                  // setAiEdits(newAiEdits);

                  contentRef.current!.innerHTML =
                    newPatientDocument?.content || "";
                  onChange?.(newPatientDocument?.content);
                }}
              ></AiAudioDocumentEditorButton>

              <DocumentBackgroundImage
                format={format}
              ></DocumentBackgroundImage>
              <div
                key={`documentContent ${patientDocument?.id}`}
                className="documentContent"
                ref={contentRef}
                style={{ opacity: 1 }}
                contentEditable
                onClick={() => {
                  onContentInput();
                }}
                onInput={() => {
                  onContentInput();
                }}
                onChange={() => {
                  onContentInput();
                }}
                dangerouslySetInnerHTML={{
                  __html: isHtmlMode
                    ? null
                    : (`${
                        isTemplate
                          ? currentContent
                          : replaceVariablesWithValues({
                              content: currentContent,
                              patientDocument,
                            })
                      }` as any),
                }}
              >
                {isHtmlMode ? currentContent?.replaceAll("<br>", "\n") : null}
              </div>
            </div>
            <DocumentFooter format={format} />
          </div>
        </div>
      </div>
    </div>
  );
}

function DocumentBackgroundImage({ format }: { format: DocumentFormat }) {
  const service = USER.get()?.service;

  return (
    <div
      className="documentBackgroundImage"
      style={{
        opacity: service?.backgroundImageOpacity,

        height:
          parseInt(service?.backgroundImageHeight?.toString() || "0") || "100%",
        width:
          parseInt(service?.backgroundImageWidth?.toString() || "0") || "100%",
        backgroundImage: `url(${getImgUrl(service?.backgroundImage)})`,
      }}
    ></div>
  );
}

function DocumentBarcode({
  patientDocument,
}: {
  patientDocument: PatientDocument | null | undefined;
}) {
  return (
    <div className="center">
      <Barcode
        value={
          getItemId(patientDocument?.patient)
            ?.replace("patients:", "")
            ?.toString()
            ?.slice(0, 8) || ""
        }
        displayValue={false}
        height={40}
        width={0.8}
        fontSize={10}
      ></Barcode>
    </div>
  );
}

function DocumentLeftBar({
  barcodeLocation,
  patientDocument,
}: {
  barcodeLocation: BarcodeLocation | null | undefined;
  patientDocument: PatientDocument | null | undefined;
}) {
  let user = USER.useSubscribe(`leftBarUser`);
  return (
    <div className="documentLeftBar">
      <div>
        <div
          dangerouslySetInnerHTML={{
            __html: user?.service?.leftBar || "<div></div>" || "",
          }}
        ></div>

        <br />
        {barcodeLocation == "margin" && (
          <DocumentBarcode patientDocument={patientDocument}></DocumentBarcode>
        )}
      </div>
    </div>
  );
}

function PrintablePatientHeader({
  folderItem,
  patientDocument,
  patient,
}: {
  folderItem: FolderItem | null | undefined;
  patient: Patient | null | undefined;
  patientDocument: PatientDocument | null | undefined;
}) {
  const unitId = getItemId((folderItem as Hospitalisation)?.bed?.unit);
  console.log("folderItem", folderItem);
  if (isCabinet())
    return (
      <div className="c2 gap5 p20" contentEditable>
        <PrintableInfoGrid name="Nom" value={patient?.lastName || "-"} />
        <PrintableInfoGrid name="Prénom" value={patient?.firstName || "-"} />
        <PrintableInfoGrid
          name="Né le"
          value={moment(patient?.birth).format("LL")}
        />
        <PrintableInfoGrid name="Age" value={getAge(patient)} />
      </div>
    );
  return (
    <div className="c2 gap10 p20">
      <PrintableInfoGrid name="Nom" value={patient?.lastName || "-"} />
      <PrintableInfoGrid name="Prénom" value={patient?.firstName || "-"} />
      <PrintableInfoGrid
        name="Né le"
        value={moment(patient?.birth).format("LL")}
      />
      <PrintableInfoGrid name="Adresse" value={patient?.address || "-"} />
      <PrintableInfoGrid
        name="Tel mobile"
        value={patient?.phoneNumber || "-"}
      />
      <PrintableInfoGrid
        name="Personne de confiance"
        value={patient?.familyMemberFullName || "-"}
        isEditable={true}
      />
      <PrintableInfoGrid
        name="N° Assurance"
        value={patient?.socialSecurityNumber || "-"}
      />
      <PrintableInfoGrid
        name="N° d'admission"
        value={moment(folderItem?._date).unix()}
        isEditable={true}
      />
      <PrintableInfoGrid
        name="Date d'entrée"
        value={moment(folderItem?._date).format("LL")}
      />
      <PrintableInfoGrid
        name="Date de sortie"
        value={moment(
          (folderItem as Hospitalisation)?.discharge?.exitDate
        ).format("LL")}
      />
      <PrintableInfoGrid
        name="Mode d'entrée"
        value={
          entryModes[(folderItem as Hospitalisation)?.entryMode as EntryMode]
            ?.name || "-"
        }
      />

      <PrintableInfoGrid
        name="Mode de sortie"
        value={
          exitModes[
            (folderItem as Hospitalisation)?.discharge?.exitMode as ExitMode
          ]?.name || "-"
        }
      />
      {unitId == "units:Mg__" && (
        <PrintableInfoGrid name="Assitant responsable" value={"Pr Ait Ali"} />
      )}
      {unitId == "units:MQ__" && (
        <PrintableInfoGrid
          name="Assitant responsable"
          value={"Dr H. Kalkoul"}
        />
      )}
      <PrintableInfoGrid
        name="Rédigé par"
        value={
          patientDocument?.creator
            ? getUserShortName(patientDocument?.creator)
            : getUserShortName(USER.get())
        }
      />
    </div>
  );
}

export function PrintableInfoGrid({
  name,
  value,
  isEditable = false,
}: {
  name: string;
  value: any;
  isEditable?: boolean;
}) {
  if (!value) return <></>;
  return (
    <div
      className="infoGrid"
      style={{ gridTemplateColumns: "100px 1fr" }}
      contentEditable={isEditable}
    >
      <div className="gray">{name}</div>
      <div className="bold">{value}</div>
    </div>
  );
}

function HtmlArea({
  ref,
  value,
  placeholder,
  rows,
  onChange,
  onBlur,
  onKeyUp,
}: {
  ref: React.RefObject<HTMLDivElement>;
  value: any;
  placeholder: any;
  rows: any;
  onKeyUp?: (newValue: any) => void;
  onChange: (newValue: any) => void;
  onBlur?: (newValue: any) => void;
}) {
  const titleRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [format, setFormat] = React.useState<DocumentFormat>("a4");
  let [content, setContent] = useState(value || "");

  return (
    <div className="htmlArea">
      <DocumentEditorContent
        isMini={true}
        currentContent={content}
        currentTitle={null}
        patientDocument={null}
        isTemplate={false}
        titleRef={titleRef}
        contentRef={contentRef}
        format={format}
        isHtmlMode={true}
        onTitleChange={() => {}}
        showHeader={false}
        showLeftBar={false}
        showTitle={false}
        onKeyUp={(newValue) => {
          content = newValue;
          onKeyUp?.(newValue);
        }}
        onChange={(newValue) => {
          content = newValue;
          onChange(newValue);
        }}
      ></DocumentEditorContent>

      <DocumentEditorToolbar
        contentRef={ref}
        patientDocument={null}
        allowedButtons={["bold", "underline", "align", "redo", "undo", "size"]}
        isHtmlMode={false}
        onFormatChange={(newFormat) => {}}
        onChange={(newValue) => {
          content = newValue;
          onChange(newValue);
        }}
      ></DocumentEditorToolbar>
    </div>
  );
}

function HtmlVisualiser({ content }: { content: string | null | undefined }) {
  if (!content) return <div></div>;
  return (
    <div
      className="htmlVisualiser"
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    ></div>
  );
}

export {
  DocumentEditor,
  DocumentEditorContent,
  HtmlArea,
  HtmlVisualiser,
  PrintablePatientHeader,
};
